import fn from '../lib/fn.js';

const formatStartLabel = function (value) {
    return value.toString();
};

const formatEndLabel = function (value) {
    if (value > 1) {
        return `${value} dager`;
    }
    return `${value} dag`;
};

export default {
    calculateSliderValue: fn.identity,
    formatFilterValue: fn.identity,
    formatStartLabel,
    formatEndLabel,
};
